var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from "react";
import { getCustomerAction, isAcap, isAlnap } from "../../../fnx/customer";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { showToastSuccessMessage } from "../../../fnx/sendSuccessMessage";
import { typeAlert } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { updateStepByPath, useGetInformationSteps } from "ah_utility/workflow";
import { insertIntoStepInformation } from "../../../utils/upsertStepInformation";
import { useCompleteStep } from "../../../utils/responseComplete";
import { useStepNavigation } from "ah_utility/NavigationEngine";
import { useLocation, useNavigate } from "react-router-dom";
import { findParamInLocalStorage } from "../../../utils/getAnyDataLocalStorge";
import { updateStepInLocalStorage } from "../../../utils/updateStapeCustom";
import { ApapAccountTypes } from "../resources/paymentSummaryDto";
import useUpdatePaymentMethod from "./useUpdatePaymentMethod";
var usePaymentSummary = function (dataForm, responseOneQuote, company, accountType, accountName, accountNumber, cardSelected, setSubTitlePayment, setDataFormPayment, setCardSelected, setSeeToast, createPolicyPendingStatus, isOnlyPaymentCreditCard, quoteIdParam, policyId, paymentCurrency) {
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var _a = useUpdatePaymentMethod(), updatePaymentMethod = _a.updatePaymentMethod, loadingUpdatePaymentMethod = _a.loadingUpdatePaymentMethod, responseUpdatePaymentMethod = _a.responseUpdatePaymentMethod, errorUpdatePaymentMethod = _a.errorUpdatePaymentMethod;
    var pathname = useLocation().pathname;
    var _b = useCompleteStep(), runComplete = _b.runComplete, loadingComplete = _b.loadingComplete;
    var _c = useGetInformationSteps(pathname), instanceId = _c.instanceId, workFlowId = _c.workFlowId, currentStep = _c.currentStep, nextStep = _c.nextStep;
    var dataNavigation = useStepNavigation({ currentStepId: pathname }).navigation;
    var clientId = React.useState(findParamInLocalStorage("clientId"))[0];
    var User = React.useState(findParamInLocalStorage("user"))[0];
    var userId = User === null || User === void 0 ? void 0 : User.userId;
    var navigate = useNavigate();
    var handleChangePayment = function (event) {
        setCardSelected(false);
        var value = event.target.value;
        if (value === "1") {
            setDataFormPayment({
                AccountName: "".concat(dataForm.Name, " ").concat(dataForm.LastNames),
            });
        }
        if (value === "4") {
            setSubTitlePayment("No. Recibo de pago");
        }
        else {
            setSubTitlePayment("");
        }
    };
    var createPolicy = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var dataSubmit, res, prevStep, currentStep_1, nextStep_1, sessionData, err_1;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0:
                    dataSubmit = {
                        data: {
                            effectiveFrom: new Date().toISOString(),
                            creationDate: new Date().toISOString(),
                            userId: userId,
                            quoteId: dataForm.QuoteId,
                            defaultStateId: createPolicyPendingStatus
                                ? "754c1e3e-e5ad-421a-a422-134b7b856eac"
                                : "",
                            //catalogStatus: "60c01b66-f07a-42f3-9ce4-bd973f515fed",
                            //paymentCurrency: "4442d70e-4013-4db2-b7e4-8d2265b219f0",
                            //accountHolderType: "e9b361e2-def7-4789-90b2-b2168c696b92",
                            accountType: getCustomerAction().customerAuto.includes(company)
                                ? ""
                                : data.type,
                            accountTypeDescription: getCustomerAction().customerAuto.includes(company)
                                ? accountType
                                : data.paymentName,
                            accountName: getCustomerAction().customerAuto.includes(company)
                                ? accountName
                                : data.AccountName && data.AccountName.replace(/\s+/g, "")
                                    ? data.AccountName.replace(/\s+/g, "")
                                    : "".concat(dataForm.Name, " ").concat(dataForm.LastNames),
                            // accountName: getCustomerAction().customerAuto.includes(company)
                            //   ? accountName
                            //   : data.AccountName.replace(/\s+/g, "")
                            //   ? data.AccountName
                            //   : `${dataForm.Name} ${dataForm.LastNames}`,
                            accountMonth: 12,
                            accountYear: 2022,
                            accountNumber: getCustomerAction().customerAuto.includes(company)
                                ? accountNumber
                                : data.AccountNumber,
                        },
                    };
                    if (isAlnap(company) && data.paymentId === "1") {
                        dataSubmit.data = __assign(__assign({}, dataSubmit.data), { accountType: "CCO", accountNumber: data.AccountNumber });
                    }
                    if (isAlnap(company) && data.paymentId === "2") {
                        dataSubmit.data = __assign(__assign({}, dataSubmit.data), { accountType: "CCO", accountNumber: data.CreditCardNumber });
                    }
                    if (getCustomerAction().customerAuto.includes(company) || isAcap(company)) {
                        if (data.paymentId === "4") {
                            dataSubmit.data = __assign(__assign({}, dataSubmit.data), { accountName: "".concat(dataForm.Name, " ").concat(dataForm.LastNames), accountNumber: data.VoucherNumber, accountType: "CCO", additionalPaymentData: {
                                    voucherDate: new Date().toISOString(),
                                    voucherAmount: parseFloat(responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.lastPrice.amount),
                                } });
                        }
                        if (data.paymentId === "5") {
                            if (!cardSelected) {
                                showToastSuccessMessage("Seleccione la cuenta de la que desea realizar el pago", typeAlert.info, setSeeToast);
                                return [2 /*return*/];
                            }
                            dataSubmit.data = __assign(__assign({}, dataSubmit.data), { accountName: accountName, accountType: isAcap(company)
                                    ? "CCO"
                                    : isOnlyPaymentCreditCard
                                        ? ApapAccountTypes.TCR
                                        : ApapAccountTypes.APAP_ACCOUNT, accountNumber: accountNumber, additionalPaymentData: {
                                    voucherDate: new Date().toISOString(),
                                    voucherAmount: parseFloat(responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.lastPrice.amount),
                                } });
                        }
                    }
                    if (quoteIdParam) {
                        updatePaymentMethod(policyId !== null && policyId !== void 0 ? policyId : "", {
                            accoutTypeId: (_a = dataSubmit.data.accountType) !== null && _a !== void 0 ? _a : "",
                            paymentCurrency: paymentCurrency !== null && paymentCurrency !== void 0 ? paymentCurrency : "",
                            number: (_b = dataSubmit.data.accountNumber) !== null && _b !== void 0 ? _b : "",
                            name: (_c = dataSubmit.data.accountName) !== null && _c !== void 0 ? _c : "",
                            accountMonth: (_d = dataSubmit.data.accountMonth) !== null && _d !== void 0 ? _d : 12,
                            accountYear: (_e = dataSubmit.data.accountYear) !== null && _e !== void 0 ? _e : new Date().getFullYear(),
                        });
                        return [2 /*return*/];
                    }
                    _l.label = 1;
                case 1:
                    _l.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, runComplete({
                            workFlowId: workFlowId,
                            instanceId: instanceId,
                            currentStep: currentStep,
                            nextStep: nextStep,
                            sessionData: __assign(__assign({}, dataSubmit.data), { clientId: clientId }),
                        })];
                case 2:
                    res = _l.sent();
                    if (res) {
                        updateStepByPath(pathname);
                        prevStep = (_f = res.upcomingFormStep) === null || _f === void 0 ? void 0 : _f.prevSteps[0];
                        currentStep_1 = (_g = res.upcomingFormStep) === null || _g === void 0 ? void 0 : _g.id;
                        nextStep_1 = (_h = res.upcomingFormStep) === null || _h === void 0 ? void 0 : _h.nextSteps[0];
                        insertIntoStepInformation({
                            stepKey: pathname,
                            data: {
                                currentStep: currentStep_1,
                                nextStep: nextStep_1,
                                prevStep: prevStep,
                            },
                        });
                        sessionData = ((_j = res.sessionData) === null || _j === void 0 ? void 0 : _j.apiResponses) || [];
                        if (sessionData.length > 0) {
                            updateStepInLocalStorage(pathname, sessionData);
                        }
                        navigate("".concat(dataNavigation === null || dataNavigation === void 0 ? void 0 : dataNavigation.next));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _l.sent();
                    setSeeToast({
                        show: true,
                        message: (_k = err_1 === null || err_1 === void 0 ? void 0 : err_1.message) !== null && _k !== void 0 ? _k : "Ocurrió un error al completar el paso.",
                        type: typeAlert.error,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return {
        handleChangePayment: handleChangePayment,
        createPolicy: createPolicy,
        loadingComplete: loadingComplete,
        loadingUpdatePaymentMethod: loadingUpdatePaymentMethod,
        responseUpdatePaymentMethod: responseUpdatePaymentMethod,
        errorUpdatePaymentMethod: errorUpdatePaymentMethod,
    };
};
export default usePaymentSummary;
